
<template>
    <div class="search-medical "> 
        <div class="medical-cont">
            <div>
                <medicalLeft @leftNavTab='leftNavTab' ></medicalLeft> 
            </div>
            <div class="medical-wrapper">
                <div class="wrapper-info">
                    <medicalTable ref="medical_table" ></medicalTable>
                </div>
            </div>
        </div>
         
    </div>
</template>

<script>
 
import medicalLeft from './medical/medical_left.vue'
import medicalTable from './medical/medical_table.vue'
import Cookies from 'js-cookie' 
import {getCookieInfo} from '../../io/getCookie.js'
export default {
    components: { 
        medicalLeft,
        medicalTable
    },
    data () {
        return { 
            highSearchWord:''
        }
    },
    mounted () { 
        this.highSearchWord=window.localStorage.getItem("highSearchWord")||getCookieInfo('highSearchWord')||''; 
    },
    methods: {  
        //左侧列表点击
        leftNavTab(item){ 
            this.leftWord=item?item.facetName:'' ;
            let leftSort = item?item.leftSort:'store';
            this.$nextTick(()=>{
                this.$refs.medical_table.initData();
                this.$refs.medical_table.getList(this.leftWord,leftSort)
            })
        },
       
    }
}
</script>

<style lang="less">
    @import url('../../css/seach_page/index.less');
</style>
